export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M12 11.479c4.147 0 6.978 3.084 6.978 7.326V20a1 1 0 0 1-1 1H6.022a1 1 0 0 1-1-1v-1.195c-.044-4.133 2.832-7.326 6.979-7.326Zm0-8.436a3.94 3.94 0 1 1 0 7.88 3.94 3.94 0 0 1 0-7.88Z"/>
</svg>
`;
